(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[630],{

/***/ "rE8b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mail", function() { return Mail; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Mail = function Mail(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.346 15.999C15.155 16.19 14.843 16.189 14.653 16L6.414 7.775C6.58 7.729 6.749 7.705 6.917 7.705H23.081C23.25 7.705 23.418 7.729 23.585 7.776L15.346 15.999ZM23.081 22.294H6.917C5.837 22.294 4.959 21.417 4.959 20.339V9.661C4.959 9.492 4.982 9.324 5.029 9.158L13.268 17.383C14.223 18.334 15.776 18.334 16.731 17.382L24.971 9.157C25.017 9.324 25.041 9.492 25.041 9.661V20.339C25.041 21.417 24.161 22.294 23.081 22.294V22.294ZM23.081 5.75H6.918C4.757 5.75 3 7.504 3 9.661V20.339C3 22.496 4.757 24.25 6.918 24.25H23.081C25.242 24.25 27 22.496 27 20.339V9.661C27 7.504 25.242 5.75 23.081 5.75V5.75Z"
  }));
};

/***/ })

}]);